import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

export default function RFQConfirmationPage() {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const t = setTimeout(() => setPhase(1), 500);
    return () => clearTimeout(t);
  }, []);

  return (
    <main style={{ paddingTop: 76, minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
      <div className="page-container" style={{ paddingTop: 64, paddingBottom: 64, textAlign: 'center', maxWidth: 640, margin: '0 auto' }}>

        {/* ── Confirmation icon ── */}
        <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 80, height: 80,
          borderRadius: '50%',
          background: phase === 1 ? '#e8f5ee' : 'transparent',
          marginBottom: 32,
          animation: phase === 1 ? 'confirmPop 0.45s cubic-bezier(0.34,1.56,0.64,1) forwards' : 'none',
          opacity: phase === 0 ? 0 : 1,
          transform: phase === 0 ? 'scale(0.5)' : 'scale(1)',
          transition: 'opacity 0.3s, transform 0.3s',
        }}>
          <CheckCircle size={40} color="#4a9e6a" strokeWidth={1.75}/>
        </div>

        {/* ── Content ── */}
        <div style={{
          opacity: phase === 1 ? 1 : 0,
          transform: phase === 1 ? 'translateY(0)' : 'translateY(16px)',
          transition: 'opacity 0.5s ease, transform 0.5s ease',
        }}>
          <h1 style={{
            fontFamily: 'var(--serif)',
            fontSize: 'clamp(28px, 6vw, 48px)',
            color: 'var(--ink)',
            lineHeight: 1.1,
            marginBottom: 16,
            textWrap: 'balance',
          }}>
            Quote Request Received
          </h1>

          <p style={{
            fontFamily: 'var(--sans)',
            fontSize: 15,
            color: 'var(--ash)',
            lineHeight: 1.7,
            marginBottom: 40,
            maxWidth: 480,
            margin: '0 auto 40px',
          }}>
            Thank you for your interest in Contractor Rob Flooring. Our team will review
            your request and reach out within 1–2 business days with a custom quote for
            your project.
          </p>

          {/* Divider */}
          <div style={{ width: 48, height: 1, background: 'var(--saffron)', margin: '0 auto 40px' }}/>

          {/* CTAs — stack on mobile */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 12,
          }}>
            <Link
              to="/catalog"
              className="btn btn-saffron btn-lg"
              style={{ display: 'inline-flex', alignItems: 'center', gap: 8, width: '100%', maxWidth: 320, justifyContent: 'center' }}
            >
              Continue Browsing
            </Link>
            <Link
              to="/"
              className="btn btn-outline btn-lg"
              style={{ display: 'inline-flex', alignItems: 'center', gap: 8, width: '100%', maxWidth: 320, justifyContent: 'center', textDecoration: 'none' }}
            >
              Back to Home
            </Link>
          </div>

          <p style={{ fontFamily: 'var(--sans)', fontSize: 12, color: 'var(--ash)', marginTop: 32, lineHeight: 1.6 }}>
            Questions? Email us at{' '}
            <a href="mailto:Info@contractorrob.com" style={{ color: 'var(--saffron-deep)', textDecoration: 'underline', textUnderlineOffset: 2 }}>
              Info@contractorrob.com
            </a>
          </p>
        </div>
      </div>

      <style>{`
        @keyframes confirmPop {
          0%   { transform: scale(0.4); opacity: 0; }
          60%  { transform: scale(1.15); opacity: 1; }
          80%  { transform: scale(0.95); }
          100% { transform: scale(1); }
        }
      `}</style>
    </main>
  );
}
